<template>
    <div class="body">
        <transition appear>
			<div v-if="!reportData" class="zhezhao">
				<div class="image" style="width: 100%; height: 13%">
					<img src="@/assets/logo1.png" style="width: 217px; height: 77px; margin-left: 7px"/>
				</div>

				<div class="right" style="width: 100%; height: 87%">
					<p class="font1" style="font-size: 86px; margin-top: 20vh;color: #1740f7;"> 2024富学宝典</p>
					<p class="font1" style=" color: #1740f7;font-size: 71px;margin-top: 20px;"> 年度学习报告 </p>
					<p class="font1" style="font-size: 41px;margin-top: 27px;color: #1740f7;"> 坚持学习的人永葆青春 </p>
				
					<div v-show="!Loading" class="input-container" style="margin-top: 4vh">
						<input v-model="jobNo" type="text" id="input" required="" />
						<label for="input" class="label">请输入工号</label>
						<div class="underline"></div>
					</div>
					<div v-show="!Loading" style="display: flex; justify-content: center;margin-top:40px;">
						<button class="button" @click="inputJobNo()">NEXT</button>
					</div>
					<!-- <LoadingAuguest v-show="Loading" style="margin-top: 30vh" /> -->
				</div>
			</div>
        </transition>
        <main v-if="reportData && reportData.studate != 0" id="main" ref="scrollDiv" class="view">
			<section id="section01" class="section">
				<!-- 有学习天数，有学分 -->
				<div v-if="reportData.studate > 0 && reportData.creditvalue > 0" style="display: flex; flex-wrap: wrap">
					<div class="left" style="width: 100%; margin-top: 10vh">
						<p class="font3" style="font-size: 30px; margin-top: 21px;">亲爱的<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>小伙伴</p>
						<p class="font3" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年已经结束</p>
						<p class="font3" style="font-size: 30px;margin-top: 15px;">感谢你与富士康科技集团携手走过<span class="font2" style="font-size: 32px;">{{ reportData.hyear }}</span>年</p>
						<p class="font3" style="font-size: 30px;margin-top: 15px;">这一年，您在富学宝典平台上的总学习天数达到了<span class="font2" style="font-size: 28px;">{{ reportData.studate }}</span >天</p>
						<p class="font3" style="font-size: 30px;margin-top: 15px;">一共获得了<span class="font2" style="font-size: 28px;">{{ reportData.creditvalue }}</span >个学分</p>
						<p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
					</div>
				</div>

				<!-- 有学习天数，没有学分 -->
				<div v-if="reportData.studate > 0 && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
					<div class="left" style="width: 100%; margin-top: 10vh">
						<p class="font1" style="font-size: 30px; margin-top: 21px;">亲爱的<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>小伙伴</p>
						<p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年已经结束</p>
						<p class="font3" style="font-size: 30px;margin-top: 15px;">感谢你与富士康科技集团携手走过<span class="font2" style="font-size: 32px;">{{ reportData.hyear }}</span>年</p>
						<p class="font3" style="font-size: 30px;margin-top: 15px;">这一年，你在富学宝典平台上的总学习天数达到了<span class="font2" style="font-size: 28px;">{{ reportData.studate }}</span >天</p>
						<p class="font3" style="font-size: 30px;margin-top: 15px;">但是还没有获得学分，请继续加油！</p>
						<p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
					</div>
				</div>

				<!-- 没有学习天数，没有学分 -->
				<div v-if="!reportData.studate && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
					<div class="left" style="width: 50%; margin-top: 20vh">
						<p class="font1" style="font-size: 30px; margin-top: 21px;">亲爱的<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>小伙伴</p>
						<p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年已经结束</p>
						<p class="font3" style="font-size: 30px;margin-top: 15px;">你还没有在富学宝典上学习，请继续加油！</p>
						<p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
					</div>
				</div>
			</section>

			<section id="section02" class="section" v-if="reportData.studate || reportData.creditvalue">
				<div class="page2" style="display: flex; flex-wrap: wrap">
					<div class="right" style="width: 100%; margin-top: 10vh">
						<p class="font3" style="font-size: 30px; margin-top: 21px;">你在富学宝典上取得的成就有:</p>

						<p class="font3" style="font-size: 30px;margin-top: 21px;">累计学习<span class="font2" style="font-size: 36px;">{{ reportData.playtime }}</span>小时</p>
						<p class="font3" style="font-size: 30px;margin-top: 21px;" v-if="reportData.rate1>0">战胜了<span class="font2" style="font-size: 36px;">{{ reportData.rate1 }}%</span>的小伙伴，位列第<span class="font2" style="font-size: 36px;">{{ reportData.rank1 }}</span>名！</p>

						<p class="font3" style="font-size: 30px;margin-top: 21px;" v-if="reportData.coursenumMon>0">你学习了<span class="font2" style="font-size: 36px">{{ reportData.coursenumMon }}</span>门课程，完成了<span class="font2" style="font-size: 36px;">{{ reportData.coursenum }}</span>门课程</p>
						<p class="font3" style="font-size: 30px;margin-top: 21px;">超越了<span class="font2" style="font-size: 1.27em;">{{ reportData.rate2 }}%</span>的小伙伴，位列第<span class="font2" style="font-size: 36px;">{{ reportData.sortId2 }}</span>名！</p>

						<p class="font3" style="font-size: 30px;margin-top: 21px;" v-if="reportData.examcount>0"> 你共参加了<span class="font2" style="font-size: 36px;">{{ reportData.examcount }}</span>场考试</p>
						<!-- <p class="font3" style="font-size: 30px;margin-top: 21px;" v-if="reportData.rate4>0">战胜了<span  class="font2" style="font-size: 36px;">{{ reportData.rate4 }}</span>名！</p> -->

						<p class="font3" style="font-size: 30px;margin-top: 21px;" v-if="reportData.coursenumF>0">其中<span class="font2" style="font-size: 36px;">{{ reportData.coursenumF }}</span>门课程考试一次就过</p>
						<p class="font3" style="font-size: 30px;margin-top: 21px;" v-if="reportData.rate5>0">超越了<span class="font2" style="font-size: 36px;">{{ reportData.rate5 }}%</span>的小伙伴，位列第<span class="font2" style="font-size: 36px;">{{ reportData.rank5 }}</span>名！</p>
					</div>
				</div>
			</section>

			<section id="section03" class="section" v-if="reportData.lesson">
				<div style="display: flex; flex-wrap: wrap">
					<div class="right" style="width: 100%; margin-top: 10vh">
						<p class="font3" style="font-size: 30px; margin-top: 21px;">🏆2024年你线下授课时数共计<span class="font2" style="font-size: 36px;">{{ this.totalHours }}</span>小时</p>
						<div style="width: 100%; margin-top: 10vh;text-align: center;">
							<p class="font1" style="font-size: 30px;">课程类别及授课时数:</p>
							<ul class="font1" style="font-size: 30px; padding-bottom: 10px;list-style-type: none;" v-for="(char, index) in lessonArray" :key="index">
							<li style="margin: 0 auto;text-align: center;margin-top: 10px;">
								<span class="font2" style="font-size: 30px;">{{ char.class_type }}</span>类课程<span class="font2" style="font-size: 30px;">{{ char.class_num }}</span>门<span class="font2" style="font-size: 30px;">{{ char.hours }}</span>小时，<span class="font2" style="font-size: 30px;">{{ char.student_num }}</span>人参与学习
							</li>  
							</ul> 
						</div>
						<p class="font2" style="padding-top: 10vh;font-size: 30px;text-align: center;">感谢你在富士康大学的授课贡献！</p>
						<p class="font2" style="font-size: 30px;text-align: center;margin-top: 15px;">你的专业输出为学员提供了宝贵的学习经验，也为富士康大家庭注入了无限活力～</p>
					</div>
				</div>
			</section>

			<section id="section04" class="section">
				<div class="page4"  style="display: flex; flex-wrap: wrap">
					<div class="title"><p class="font2" style="font-size: 60px;text-align: center;">好书推荐</p></div>
					<div class="left" style="margin-top: 40px;width: 80%;margin: 0 auto;">
						<div class="detail">
							<p style="text-align: center;font-size: 30px;font-family: font1;color: #1740f7;">《第五项修炼》</p>
							<p class="font2" style="font-size: 18px;text-align: center;">彼得·圣吉</p>
						</div>
						<div class="bookDetail" style="font-size: 17px;padding: 20px;color: #1740f7;">
							<span style="font-size: 20px;">
							《第五项修炼》被《金融时报》称为有影响力的五部工商巨著之一，被《哈佛商业》称为过去75年有影响力的管理类图书。<br><br>
							书中明确提出了“学习型组织”的管理概念，以及如何通过五项修炼来打造有超强学习力的学习型组织，强调从事一项修炼就意味着成为一个终身学习者。<br><br>
							在互联网时代，从个人学习到组织深度学习再到社会创新，每一个个体，组织机构都要完成五项修炼，而第五项修炼——系统思考带来认知未来的全局思维，是每个人要学习的一项修炼。<br>
							</span>
						</div>
					</div>
					<div class="right" style="margin-top: 40px;width: 80%;margin: 0 auto;">
						<div class="detail">
							<p style="text-align: center;font-size: 30px;font-family: font1;color: #1740f7;">《五项修炼的故事》</p>
							<p class="font2" style="font-size: 18px;text-align: center;">大卫·哈钦斯</p>
						</div>
						<div class="bookDetail" style="font-size: 17px;padding: 20px;">
							<span style="font-size: 20px;text-align: justify;color:#1740f7;">
								你可能听过第五项修炼，但从未真正理解。本书以美式漫画风格，搭配译者导读和故事剖析，告诉你如何突破思考盲点、了解心志模式、建立系统思考、设定目标和愿景、学会有效沟通，让你真正掌握五项修炼的精义！<br><br>
								学习型组织之父，管理大师彼得·圣吉说：“当我们能做以前所不能的事时，就知道自己在学习了。”<br><br>  
								学习是一种修炼，是一种生存与处世之道。在这个快速变迁的时代，终身学习更是保障自己免于被淘汰的必要修炼！<br>  
							</span>
						</div>
					</div>         
				</div>
			</section>

			<section id="section05" class="section" v-if="reportData.activity || reportData.activity2">
				<div class="page5"  style="flex-wrap: wrap">
					<div class="right" style="width: 100%; margin-top: 10vh">
						<p class="font3" style="font-size: 30px; margin-top: 21px;">2024年你的个人发展与成长是：</p>
						<p class="font3" v-if="this.count!=0" style="font-size: 30px; padding-top: 1vh;"> 完成了<a class="font2">{{ this.count }}</a>个认证培训项目学习</p>
						<p class="font3" v-if="this.count1!=0" style="font-size: 30px;"> 获得了<a class="font2">{{ this.count1 }}</a>个证书</p>
						<div>
							<p class="font3" style="font-size: 30px;" v-if="this.course!==''"> 完成了<a class="font2" style="font-size: 30px;">{{ this.course }}</a>培训</p>
							<p class="font3" style="font-size: 30px;" v-if="this.promote!==''"> 顺利晋升为<a class="font2" style="font-size: 30px;">{{ this.promote }}</a></p>
							<p class="font3" style="font-size: 30px;" v-if="this.teacher!==''"> 通过讲师认证，成为<a class="font2" style="font-size: 30px;">{{ this.teacher }}</a></p>
						</div>   
					</div>           
				</div>
				<p class="font2" style="padding-top: 5vh;font-size: 30px;text-align: center;">鹰击天风壮，鹏飞海浪春</p>
			</section>

			<section id="section06" class="section">
				<div class="page5" style="position: relative;top: 10vh;">
					<div style="margin: 0 auto;margin-top: 10vh">
						<p class="font2" style="font-size: 30px; text-align: center;">你希望在富学宝典平台上遇见哪些好课程呢?</p>
						<p class="font2"  style="font-size: 28px;text-align: center;margin-top: 2vh;">请写下你的学习清单吧！</p>
						<form id="form" class="topBefore">
							<textarea id="message" v-model="comment" type="text" placeholder="MESSAGE"></textarea>
							<input id="submit"  @click="submit" type="button" value="OK!" />
						</form>
					</div>
					<div style="padding-top: 70px;margin: 0 auto;">
						<p style="font-size: 48px;text-align: center;color: #1740f7;">THANK YOU!</p>
						<p class="font2" style="font-size: 48px;text-align: center;">一旦决心学习，谁也拦不住你</p>
					</div>
				</div>
			</section>
        </main>
    </div>
</template>

<script>
import Loading from './Loading.vue'
import viewApi from "@/api/view";
import dataApi from "@/api/data";
import { getArray } from "../../utils/encourage";
export default {
    data(){
		return{
			Loading:false,
			reportData:'',
			jobNo:'',
			source: "",
			comment:'',

			lessonArray:[],
			totalHours:0,
			classType:'',
			sutdentNum:0,

			activityArray:[],
			course:'',
			promote:'',
			teacher:'',
			count:0,
			count1:0,
		}
    },
    created(){
		document.title = "2024年度学习报告";
		/* 相信数据begin */
		var test = window.location.href
		let arr = test.split("?code=")
		this.code = arr[1]
		if (this.code) {
			viewApi.getJobNoByBelieve(this.code).then((res) => {
			if(res.data.code === 200) {
				this.jobNo = res.data.data.jobNo
				this.source = "相信"
				if (this.jobNo) {
					this.Loading = true;
					this.getData()
				}
			}
			})
		}
		/* 相信数据end */
    },
    methods:{
		submit() {
			if (!this.comment) {
				this.$message({
					message: "请说说您的学习计划",
					type: "warning",
					center: true,
				});
			} else if (this.comment) {
				const view = {
					comment: this.comment,
					studyList: this.studyList,
				};
				view["id"] = this.viewId;
				console.log(view);
				viewApi.update(view).then((res) => {
				if (res) {
					this.$message({
						message: "提交成功，感谢您的留言。",
						type: "success",
						center: true,
					});
				}
				});
			}
		},
		inputJobNo() {
				if (this.Loading === true) {
					return;
				}
				if (this.jobNo) {
					this.Loading = true;
					this.getData();
				} else {
					this.$message({
						message: "请输入工号",
						type: "warning",
						center: true,
					});
				}
		},
		getData() {
			dataApi.getDataFor24Year(this.jobNo).then((res) => {
				this.reportData = res.data.data.data;

				this.lessonArray = JSON.parse(this.reportData.lesson)
				if(this.lessonArray){
					this.lessonArray.forEach(element => {
						this.totalHours+=parseInt(element.hours)
					});
				}

				const activityArray = JSON.parse(this.reportData.activity2)
				const activityArray1 = JSON.parse(this.reportData.activity)
				if(activityArray1){
					this.count=activityArray1.length
					activityArray1.forEach(element => {
						if (element.certificate!=='无') {
							this.count1++
						}
					});
				}
				if(activityArray){
					activityArray.forEach(element => {
						if(element.name=='讲师评审'){
							this.teacher=element.certificate
						}else if(element.name=='晋升'){
							this.promote=element.certificate
						}else{
							this.course=element.name
						}
					});
				}
				
				if (this.reportData) {
					this.sendViewRecords();
					this.Loading = false;
					this.reportData.textLab = getArray(this.reportData.textLab);
				} else if (!this.reportData) {
					this.$message({
						message: "抱歉，暂时找不到您的学习报告！",
						type: "warning",
						center: true,
					});
					this.Loading = false;
				}
				});
		},
		sendViewRecords() {
			if (this.jobNo) {
				let viewData = {
					jobNo: this.jobNo,
					device: "PC",
					type: 26,
					browser: this.browser,
				};
				if (this.source) {
					viewData["source"] = this.source;
				}
				viewApi.view(viewData).then((res) => {
					this.viewId = res.data.data.data.id;
				});
			} else {
				return;
			}
		},
    },
}
</script>

<style scoped>
* {
	margin: 0;
	padding: 0;
}
/* 字体样式 */
.font1{
	color: #5169d5; 
	font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
	font-weight: 700; 
	text-align: center;
}
.font2{
	color: #1740f7; 
	font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
	font-weight: 700; 
}

.font3{
	color: #1740f7; 
	font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
	text-align: center;
}
/* 第一页 */
.body {
	width: 100vw;
	height: 100vh;
	position: absolute;
	left: 0;
	top: 0;
	overflow: hidden;
}

.zhezhao {
	width: 100vw;
	height: 100vh;
	/* background-image: linear-gradient(170deg, #b55d7f , #953b5d); */
	background:url("../../assets/24year/pcbg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	position: absolute;
	display: flex;
	flex-wrap: wrap;
}
.input-container {
	position: relative;
	margin: 50px auto;
	width: 400px;
}

.input-container input[type="text"] {
	font-size: 20px;
	width: 100%;
	border: none;
	border-bottom: 2px solid #ccc;
	padding: 5px 0;
	background-color: transparent;
	outline: none;
	color: #1740f7;
}

.input-container .label {
	position: absolute;
	top: 0;
	left: 0;
	color: #ccc;
	transition: all 0.3s ease;
	pointer-events: none;
}

.input-container input[type="text"]:focus ~ .label,
.input-container input[type="text"]:valid ~ .label {
	top: -20px;
	font-size: 16px;
	color: #fff;
}

.input-container .underline {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 2px;
	width: 100%;
	background-color: #fff;
	transform: scaleX(0);
	transition: all 0.3s ease;
}

.input-container input[type="text"]:focus ~ .underline,
.input-container input[type="text"]:valid ~ .underline {
  	transform: scaleX(1);
}
.button {
	--bg: #1740f7;
	--text-color: #fff;
	position: relative;
	width: 150px;
	height: 40px;
	border: none;
	background: var(--bg);
	color: var(--text-color);
	padding: 1em;
	font-weight: bold;
	text-transform: uppercase;
	transition: 0.2s;
	border-radius: 5px;
	opacity: 0.8;
	letter-spacing: 1px;
  	box-shadow: #6076dc 0px 7px 2px, #000 0px 8px 5px;
}

.button:hover {
  	opacity: 1;
}

.button:active {
	top: 4px;
	box-shadow: #6e2441 0px 3px 2px, #000 0px 3px 5px;
}

/* 第二页 */
.view {
	width: 100%;
	height: 100%;
	background:url("../../assets/24year/pcbg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	/* background-image: linear-gradient(170deg, #7a94ac , #a2bed8); */
}
main {
	scroll-snap-type: y mandatory;
	scroll-padding: 80px;
	overflow: scroll;
	height: 100vh;
}
section {
	width: 100vw;
	height: 100vh;
	scroll-snap-align: start;
}
#section01,#section02,#section03,#section04{
  	position: relative;
}

/*书籍推荐页 */
.title {
	font-size: 50px;
	width: 100%;
	margin-bottom: 30px;
	margin-top: 30px;
}


/* 最后的输入框 */
#form {
	position: relative;
	width: 40vw;
	padding-top: 50px;
	margin: 0 auto;
}

input {
	font-family: "Lato", sans-serif;
	font-size: 0.875em;
	width: 570px;
	height: 50px;
	padding: 0px 15px 0px 15px;
	background: transparent;
	outline: none;
	color: #ffffff;
	border: solid 1px #fff;
	border-bottom: none;
	transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-moz-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
}

input:hover {
	background: #fff;
	color: #fff;
}

textarea {
	width: 40vw;
	max-width: 40vw;
	height: 20vh;
	max-height: 20vh;
	padding: 0;
	background: transparent;
	outline: none;
	color: #fff;
	font-family: "Lato", sans-serif;
	font-size: 0.875em;
	border: solid 1px #fff;
	transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-moz-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
}

/* textarea:hover {
  background: #e89fbb;
  color: #fff;
} */

#submit {
	width:  40vw;
	padding: 0;
	margin: -5px 0px 0px 0px;
	font-family: "Lato", sans-serif;
	font-size: 0.875em;
	color: #000;
	outline: none;
	cursor: pointer;
	border: solid 1px #fff;
	border-top: none;
}

#submit:hover {
  	color: #b3aca7;
}

</style>